import { render, staticRenderFns } from "./CAxACGxPerceptionPage.vue?vue&type=template&id=09fb0a0a"
import script from "./CAxACGxPerceptionPage.vue?vue&type=script&lang=js"
export * from "./CAxACGxPerceptionPage.vue?vue&type=script&lang=js"
import style0 from "./CAxACGxPerceptionPage.vue?vue&type=style&index=0&id=09fb0a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports